import { render, staticRenderFns } from "./wangeditor.vue?vue&type=template&id=085479ec&"
import script from "./wangeditor.vue?vue&type=script&lang=js&"
export * from "./wangeditor.vue?vue&type=script&lang=js&"
import style0 from "@wangeditor/editor/dist/css/style.css?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports